import { Grid } from '@mui/material';

import { PageTitle } from 'main/components/_common/BasePage/PageTitle';
import { EmbeddedVideo } from './EmbeddedVideo';
import { UploadButton } from './UploadButton';
import { ProgressBackdrop } from 'main/components/_common/ProgressBackdrop';
import { AlertSnackbar } from 'main/components/_common/AlertSnackbar';

export const SharedVideosPage = () => {
    const videoIds = [
        '8dxF2UQpOI0'
    ]

    return (
        <Grid container direction="column" pt={1} px={2} spacing={2}>
            <Grid item>
                <PageTitle>共有動画</PageTitle>
            </Grid>
            <Grid item>
                <Grid container direction="row">
                    <Grid item>
                        <UploadButton />
                    </Grid>
                </Grid>
            </Grid>
            {videoIds.map(videoId => (
                <Grid item key={videoId}>
                    <EmbeddedVideo videoId={videoId} />
                </Grid>
            ))}
            <ProgressBackdrop />
            <AlertSnackbar />
        </Grid>
    )
}


// ログインしたら、おすすめ動画、共有動画メニューを表示
// おすすめ動画には、roleに応じて、タブ(選手向け、保護者向け、コーチ向け)が変更
// 共有動画は、タブどうする？？？

// おすすめ動画登録


// 動画アップロード
// 公開/非公開
// 撮影日
// 分類(タブ)：練習、試合、
// タイトル
// 詳細説明
